import { ModalBody } from './modal-body';
import { ModalHeader } from './modal-header';
import useLockScroll from 'hooks/use-lock-scroll';
import { useEffect } from 'react';

export const WarrantyLogsCreateModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  useLockScroll();

  return (
    <>
      <div className="modal fade show d-block" id="kt_modal_Files" role="dialog" tabIndex={-1} aria-modal="true">
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered modal-md">
          {/* begin::Modal content */}
          <div className="modal-content">
            <ModalHeader />
            {/* begin::Modal body */}
            <div className="modal-body scroll-y pt-3">
              <ModalBody />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};
